import { render, staticRenderFns } from "./BuroCreditoList.vue?vue&type=template&id=2ee622f5&scoped=true&"
import script from "./BuroCreditoList.vue?vue&type=script&lang=js&"
export * from "./BuroCreditoList.vue?vue&type=script&lang=js&"
import style0 from "./BuroCreditoList.vue?vue&type=style&index=0&id=2ee622f5&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee622f5",
  null
  
)

export default component.exports